import MaterialTable from "material-table";
import { useEffect } from "react";
import {
  Box,
  Button,
  Select,
  Typography,
  MenuItem,
  Grid,
  CircularProgress,
  IconButton,
  TextField,
  FormControl,
  FormLabel,
  Tooltip,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper,
  RadioGroup, Radio, FormControlLabel
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";
import {
  ConvertDate,
  getUserData,
  getUserId,
  revertDateFormat,
} from "../../../Base/helper/baseFunctions";
import Popup from "../../../Base/views/Popup";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import {
  DeleteVMBulkUploadStageHelper,
  GetVMBulkUploadStageHelper,
  UpdateVMBulkUploadStageHelper,
  AddVisitorStagetoMainHelper,
} from "../../helper/BulkUpload/VisitorBulkUploadHelper";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import Papa from "papaparse";
import Warning from "../../Images/report.png";
import { useDispatch, useSelector } from "react-redux";
import { GetVisitorReasonActions } from "../../../../../store/Employee/Visitors/Action";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import {
  GetVMMultipleOrgConfigurationHelper,
  GetVMOrgTypeHelper,
} from "../../../VisitorSettings/helper/OrgType/OrgTypeHelper";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { AddEmailTokenHelper } from "../../../Ancillary/EmailToken/helper/EmailTokenHelper";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetEmployeesAndExternalUsersHelper } from "../../../Employee/helper/EmployeeHelper";
import { sendWhatsAppTextMessageHelper } from "../../../Whatsapp/helper/TemplateHelper";
import { BASE_URL } from "../../../../Constants/baseConstant";

const PreRegistrationBulkUpload = () => {
  let userData = getUserData();
  const [, setOpenBulk] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [show, setShow] = useState(false);
  const [editedRecord, setEditedRecord] = useState(null);
  const [id, setId] = useState(); 
  const [openPopup, setOpenPopup] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [errors, setErrors] = useState({});
  const [editerrors, setEditErrors] = useState({});
  const [visitorData, setVisitorData] = useState([]);
  const [stageData, setStageData] = useState([]);
  const [file, setFile] = useState(null);
  const [resWarData, setResWarData] = useState({
        type: "",
        warning: "",
        stage_visitor_pk: "",
        isOpen: false
    });
  const initialColMapping = [
    { excel: "", db: "visitors_name", label: "Guest Name", required: true },
    { excel: "", db: "visitors_mobile_no", label: "Guest Mobile Number", required: true },
    { excel: "", db: "booking_date", label: "Visit Date", required: true },
    { excel: "", db: "reason", label: "Purpose of Visit", required: true },
    // org_name : send as payload and mapped from backend;
    //visitor_reason_comment : token (getting generated from backend;)
  ];
  const dispatch = useDispatch();
  const [excelDbColMapping, setExcelDbColMapping] = useState(initialColMapping);
  const [rowHeaders, setRowHeaders] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [getLoading, setGetLoading] = useState(false);
  const [gridLoading, setGridLoading] = useState(false);
  const [isSingleOrg, setIsSingleOrg] = useState(true);
  const [bulkFormData, setBulkFormData] = useState({
    employee_id: ""
  })
  const [sendWhatsappMsg, setSendWhatsappMsg] = useState("no");
  const [employeesData, setEmployeesData] = useState({
        load: true,
        values: [],
  });
  const { visitor_reasons, visitorLoading } = useSelector(
    (state) => state?.EmployeeReducer?.VisitorsReducer,
  );
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const whatsAppFlow = atsModuleData?.find((item) => item.module_name === "Whatsapp Flow");
  const { whatsappConfigData } = useSelector((state) => state?.AncillaryReducer?.WhatsappConfigReducer);
  const [employeesOptions, setEmployeesOptions] = useState([]);

  const handleEmployees = () => {
      employeesOptions &&
        setEmployeesData({ load: false, values: employeesOptions });
  };
  const handleReset = () => {
    setExcelDbColMapping(initialColMapping);
    setFile(null);
    setBulkFormData({
        employee_id: ""
    });
    setSendWhatsappMsg("no");
  };

  const handleWhatsappRadioChange = (e) => {
    const val = e.target.value;
    if (val === "yes") {
      const configObj = whatsappConfigData?.[0] || {};
      const rawPhone = configObj?.whatsapp_business_number || "";
      let cleanPhone = String(rawPhone).replace(/[^0-9]/g, "");
      if (!cleanPhone) {
        toast.dismiss();
        toast.error("WhatsApp phone number is not configured. Please configure it under Settings > General > Configuration.");
        setSendWhatsappMsg("no");
        return;
      }
    }
    setSendWhatsappMsg(val);
  };

  const handleSendWhatsappInvite = async (token, infoData) => {
    try {
      const passUrl = `${BASE_URL}/vm-guestpass-download-portal?${token}`;
      const hostName = infoData?.visited_employee_name || "-";
      const visitDate = infoData?.booking_date ? ConvertDate(infoData?.booking_date) : (infoData?.booking_date || "-");
      const visitorName = infoData?.visitors_name || "Guest";
      const mobileNo = infoData?.visitors_mobile_no;

      if (!mobileNo) return;

      const messageText = `Hi ${visitorName},\n\nYour visit has been pre-registered successfully.\n\nVisit Date: ${visitDate}\nHost: ${hostName}\n\nTo access your Check-In QR Pass, please click the link below:\n${passUrl}\n\nYou can download and show the QR pass at the entry gate during check-in.\n\npowered by Meepl`;

      sendWhatsAppTextMessageHelper({
        number: mobileNo,
        message: messageText,
        preview_url: true,
        show: infoData?.show,
        toastMessage: infoData?.toastMessage
      });
    } catch (err) {
      console.error("Error sending WhatsApp invite:", err);
    }
  };
  useEffect(() => {
    setGetLoading(true);
    GetVMBulkUploadStageHelper()
      .then((res) => {
        setGetLoading(false);
        setVisitorData(
          res?.data?.data?.[0]
            ?.pre_registration_visitors_detail_stage_details || [],
        );
        setStageData(res?.data?.data || []);
        setId(res?.data?.data?.[0]?.pre_registration_visitors_detail_stage_pk);
      })
      .catch((err) => {
        setGetLoading(false);
        console.error("Error fetching bulk upload stage:", err);
      });
    dispatch(GetVisitorReasonActions());
    GetVMOrgTypeHelper().then((res) => {
      if (res?.data?.statuscode === 200) {
        setIsSingleOrg(res?.data?.data?.[0]?.is_vm_org_type_single);
      }
    });
    GetEmployeesAndExternalUsersHelper().then((res) => {
      if (res?.data?.statuscode === 200) {
        setEmployeesData({ load: false, values: res?.data?.data });
        setEmployeesOptions(res?.data?.data);
      } else {
        setEmployeesData({ load: false, values: [] });
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectFileClick = () => {
    if (stageData?.length > 0 || visitorData?.length > 0) {
      setShowConfirmPopup(true); // Show confirmation popup if data exists
    } else {
      document.getElementById("contained-button-file").click(); // Directly trigger file selection if no data exists
    }
  };
  const fileSelected = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    if (!selectedFile.name.endsWith(".csv")) {
      setShow(true);
      return;
    }
    processCSVFile(selectedFile, e);
  };
  const processCSVFile = (selectedFile, event) => {
    setFile(selectedFile);
    setUploadProgress(0);
    toast.info("Reading CSV File. Please wait...");

    Papa.parse(selectedFile, {
      header: true,
      skipEmptyLines: true,
      beforeFirstChunk: (chunk) => {
        const filteredChunk = chunk
          ?.split("\n")
          ?.filter((line) => !line?.trim()?.startsWith("#"))
          ?.join("\n");
        return filteredChunk;
      },
      complete: (result) => {
        const headers = Object.keys(result.data[0]); // Extract CSV headers
        setRowHeaders(headers);
        toast.dismiss();
        toast.success("File imported successfully!");
      },
      error: (error) => {
        toast.error(`Error reading CSV file: ${error.message}`);
      },
    });

    if (event) event.target.value = ""; // Reset the input
  };
  function setColMapping(value, dbCol) {
    setExcelDbColMapping((prev) => {
      prev.forEach((col) => {
        if (col["db"] === dbCol) col.excel = value;
      });
      return [...prev];
    });
  }
  function clearColMapping(dbCol) {
    setExcelDbColMapping((prev) => {
      prev.forEach((col) => {
        if (col["db"] === dbCol) col.excel = "";
      });
      return [...prev];
    });
  }
  const validate = (fieldValues) => {
    const temp = {};
    if (!file) temp.file = "File is required";
    const unmappedRequiredFields = excelDbColMapping.filter(
      (col) => col.required && !col.excel,
    );
    if (unmappedRequiredFields.length > 0) {
      toast.dismiss();
      toast.error("Please map all required fields.");
      temp.columnMapping = "Please map all required fields.";
    }
    if ("employee_id" in fieldValues) {
      temp.employee_id =
        fieldValues.employee_id === "" || fieldValues.employee_id === null
          ? "Host/Person to Meet is required"
          : "";
    }
    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };

  async function addVisitorStage(e) {
if (!validate(bulkFormData)) return;
    e.preventDefault();
    let multiple_org_configuration = null;
    const id = getUserData()?.multiple_org_configuration;
    if (!isSingleOrg && id) {
      const res = await GetVMMultipleOrgConfigurationHelper();
      if (res?.data?.statuscode === 200) {
        const resData = res?.data?.data;
        const findData = resData?.filter(
          (el) => +el.multiple_org_configuration_pk === +id,
        );
        multiple_org_configuration = findData?.length ? findData[0] : null;
      }
    }
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("user_id", getUserId());
      formData.append("domain_name", userData?.domain);
      formData.append(
        "multiple_org_configuration",
        multiple_org_configuration
          ? JSON.stringify(multiple_org_configuration)
          : "",
      );
      formData.append("visiting_employee_id", bulkFormData?.employee_id ? JSON.stringify(bulkFormData?.employee_id) : "")
      formData.append("send_whatsapp_invite", sendWhatsappMsg)
      formData.append("column_mapping", JSON.stringify(excelDbColMapping));
      toast.info("Uploading file");
      try {
        setUploadProgress(0);
        await axiosInstance
          .post("/visitors/uploadVisitorFile", formData, {
            baseURL: HRMS_EMPLOYEE_API_URL,
            headers: {
              Accept: "multipart/form-data",
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progress) => {
              const percentCompleted = Math.round(
                (progress.loaded * 90) / progress.total,
              );
              setUploadProgress(percentCompleted);
              if (percentCompleted > 89) {
                toast.dismiss();
                toast.info("Uploading...");
              }
            },
          })
          .then((response) => {
            const result = response?.data?.statuscode;
            setVisitorData(
              response?.data?.data?.[0]
                ?.pre_registration_visitors_detail_stage_details || [],
            );
            setStageData(response?.data?.data || []);
            setId(
              response?.data?.data?.[0]
                ?.pre_registration_visitors_detail_stage_pk,
            );
            if (result === 200) {
              toast.dismiss();
              toast.success("File uploaded successfully!");
            }
          });

        setUploadProgress(100);
        handleReset();
      } catch (error) {
        setUploadProgress(0);
        toast.warning(error.response?.data?.message || error.message);
      }
    } catch (error) {
      console.error("Unexpected error", error);
    }
  }
  const handleValidateEachField = () => {
    const warningObj = {};
    const mobileRegex = /^\d{10}$/;
    (visitorData || [])?.forEach((visitor) => {
        const reasons = [];

        if (!visitor?.visitors_name) {
        reasons.push("Guest Name is required");
        }
        if (!visitor?.visitors_mobile_no) {
        reasons.push("Mobile Number is required");
        } else if (!mobileRegex.test(visitor?.visitors_mobile_no)) {
        reasons.push("Invalid 10-digit Mobile Number");
        }
        if (!visitor?.booking_date) {
        reasons.push("Visit Date is required");
        }

        if (!visitor?.reason) {
        reasons.push("Purpose of Visit is required");
        }

        if (reasons.length > 0) {
        warningObj[visitor?.visitor_reason_comment] = {
            visitor_name: visitor?.visitors_name || "-",
            reasons,
        };
        }
    });

    if (Object.keys(warningObj).length > 0) {
        setResWarData({
        type: "Warning",
        warning: warningObj,
        stage_visitor_pk: id,
        isOpen: true,
        });
        return false;
    }

    return true;
    };
  async function handleSubmit(e) {
    if (!handleValidateEachField()) return;
    const visitingEmpId = visitorData?.length ? visitorData?.[0]?.visited_employee_email : ""
    if (!visitingEmpId) {
        toast.error("Host Id is missing");
        return;
    }
    AddVisitorStagetoMainHelper({visited_employee_email: visitingEmpId})
      .then((res) => {
        if (res.data.statuscode === 200) {
          toast.dismiss();
          toast.success("File processed successfully!");
          const resData = res?.data?.data?.[0]?.fn_upsert_imported_pre_registration_visitors;
          const reasonsList = resData?.reasons || [];
          const employeesList = resData?.employees || [];
          const failedWarnings = {};
          let isFirstWhatsappMsg = true;
          (visitorData || [])?.forEach((visitor, index) => { 
            if (reasonsList?.length && employeesList?.length && reasonsList?.[index]) {
                const itemReason = reasonsList?.[index] || {};
                const itemReasonAvailable = itemReason?.reason && itemReason?.visitors_management_reasons_pk;
                if (itemReasonAvailable) {
                    AddEmailTokenHelper({
                        token: visitor?.visitor_reason_comment,
                        json_data: JSON.stringify([
                        {...visitor,
                            employee_id : {
                                name : visitor?.visited_employee_name,
                                office_email : visitor?.visited_employee_email,
                            },
                            visitors_management_reasons_pk : {
                                visitors_management_reasons_pk: itemReason?.visitors_management_reasons_pk,
                                reason: itemReason?.reason
                            },
                            id_proof: "",
                            vehicle_no: "",
                            multiple_org_configuration_fk: {
                                multiple_org_configuration_pk: visitor?.multiple_org_configuration_pk,
                                org_name: visitor?.org_name,
                            }
                        }]),
                    });
                    if (sendWhatsappMsg === "yes" || visitor?.send_whatsapp_invite === "yes") {
                      handleSendWhatsappInvite(visitor?.visitor_reason_comment, {
                        ...visitor,
                        show: isFirstWhatsappMsg,
                        toastMessage: "WhatsApp message sending started...",
                      });
                      isFirstWhatsappMsg = false;
                    }
                } else {
                    const reasons = [];
                    if (!itemReasonAvailable) {
                        reasons.push(
                            `Purpose of Visit "${visitor?.reason || "-"}"`
                        );
                    }
                    failedWarnings[visitor?.visitor_reason_comment] = {
                        visitor_name: visitor?.visitors_name || "-",
                        reasons,
                    };
                }
            }       
          });
            if (Object.keys(failedWarnings).length > 0) {
                setResWarData({
                    type: "Failed",
                    warning: failedWarnings,
                    stage_visitor_pk: id,
                    isOpen: true,
                });
            }
          setVisitorData([]);
          setStageData([]);
        } else {
          toast.error("The bulk upload failed. Please try again");
        }
      })
      .catch((err) => {
        toast.error("Error processing bulk upload");
        console.error(err);
      });
  }

  const [loader, setLoader] = useState(false);
  const handleCancel = () => {
    setLoader(true);
    DeleteVMBulkUploadStageHelper({
      pre_registration_visitors_detail_stage_pk:
        stageData?.length > 0 ? null : id,
    })
      .then((res) => {
        setLoader(false);
        setShowConfirmPopup(false);
        if (res.data.statuscode === 200) {
          setStageData([]);
          setVisitorData([]); // Clear table data
          setFile(null); // Allow new file selection
          document.getElementById("contained-button-file").click();
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((err) => {
        setLoader(false);
        toast.error("Error clearing data");
      });
  };
  const handleEdit = (rowData) => {
    setEditedRecord(rowData);
    setOpenPopup(true);
  };
  const handleConfirmDelete = (rowData) => {
    setOpenDialog(true);
    setCurrentData(rowData);
  };
  const handleDelete = () => {
    const updatedData = visitorData?.filter(
      (visitor) =>
        visitor?.visitor_reason_comment !== currentData?.visitor_reason_comment,
    ); // Use unique field
    setOpenDialog(false);
    setGridLoading(true);
    UpdateVMBulkUploadStageHelper({
      pre_registration_visitors_detail_stage_pk: id,
      pre_registration_visitors_detail_stage_details:
        JSON.stringify(updatedData),
    })
      .then((res) => {
        if (res?.data?.statuscode === 200) {
          setVisitorData(updatedData); // Update state
          toast.success("Record deleted successfully!");
        }
      })
      .catch((err) => {
        toast.error("Error deleting record");
      })
      .finally(() => {
        setGridLoading(false);
      });
  };
  const handleEditSubmit = (updatedRecord) => {
    if (!validateFields()) return;
    const updatedData = visitorData?.map((visitor) =>
      visitor?.tableData?.id === updatedRecord?.tableData?.id
        ? updatedRecord
        : visitor,
    );
    setGridLoading(true);
    UpdateVMBulkUploadStageHelper({
      pre_registration_visitors_detail_stage_pk: id,
      pre_registration_visitors_detail_stage_details:
        JSON.stringify(updatedData),
    })
      .then((res) => {
        if (res?.data?.statuscode === 200) {
          setVisitorData(updatedData); // Update state
          toast.success("Record updated successfully!");
        }
      })
      .catch((err) => {
        toast.error("Error updating record");
      })
      .finally(() => {
        setGridLoading(false);
      });
    setOpenPopup(false); // Close popup
  };
  const validateFields = () => {
    const tempErrors = {};
    const mobileRegex = /^\d{10}$/;
    if (!editedRecord?.visitors_name)
      tempErrors.visitors_name = "Guest Name is required.";
    if (!editedRecord?.visitors_mobile_no) {
      tempErrors.visitors_mobile_no = "Mobile number is required.";
    } else if (!mobileRegex.test(editedRecord.visitors_mobile_no)) {
      tempErrors.visitors_mobile_no = "Enter a valid 10-digit number.";
    }
    if (!editedRecord?.booking_date)
      tempErrors.booking_date = "Visit Date is required.";
    if (!editedRecord?.visited_employee_name)
      tempErrors.visited_employee_name = "Host/Person to Meet is required.";
    if (!editedRecord?.reason)
      tempErrors.reason = "Purpose of Visit is required.";
    setEditErrors(tempErrors);
    return Object.keys(tempErrors).length === 0; // Return true if no errors
  };
  const sampleData = [
    [
      "Guest Name",
      "Guest Mobile Number",
      "Visit Date",
      "Purpose of Visit",
    ],
    ["John Doe", "9876543210", "22-05-2026", "Business Meeting"],
  ];
  const commonGuides = [
    "Guest Name: Full name of the visitor.",
    "Guest Mobile Number: 10-digit mobile number for official communication.",
    "Visit Date: dd-mm-yyyy format (e.g. 22-05-2026)",
    `Purpose of Visit: ${visitor_reasons?.length ? visitor_reasons?.map((r) => r.reason).join(" / ") : "N/A"}`,
    "Do not modify the spelling, spaces or letter casing for Purpose of Visit fields.",
    "Do Not remove these lines starting with '#' (they are for guidance only)",
  ];
  const handleDownload = () => {
    const ws = XLSX.utils.aoa_to_sheet(sampleData);
    let csv = XLSX.utils.sheet_to_csv(ws);
    const allGuides = [
      `Visitor Bulk Pre-Registration Guide (Input Format)`,
      ...commonGuides,
    ];
    if (allGuides?.length > 0) {
      const guideText =
        allGuides?.map((line) => `########## ${line} ##########`)?.join("\n") +
        "\n####\n####\n";
      csv = guideText + csv;
    }
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Sample_Visitors.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

const handleExportWarningListExcel = () => {
  const warningType = resWarData?.type === "Warning"
  const colName = warningType ? "Warning" : "Reason"
  const data = Object.values(resWarData?.warning || []).map((item) => {
    const row = {
      "Guest Name": item?.visitor_name || "-",
    };

    item?.reasons?.forEach((reason, index) => {
      row[`${colName} ${index + 1}`] = reason;
    });

    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(data);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    `Visitor Validation ${colName}s`
  );

  XLSX.writeFile(
    workbook,
    `Visitor_Bulk_PreRegistration_${colName}s.xlsx`
  );
};
  return (
    <>
      <Popup
        maxWidth="xs"
        openPopup={show}
        setOpenPopup={setShow}
        close={false}
        hideDividers={true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
            <img src={Warning} alt="UnSupport File" width={"25%"} />
          </Box>
          <FormControl>
            <FormLabel id="gender-label">
              <Typography variant="h5" className="blink">
                Invalid File Type, Accepted file type is .csv
              </Typography>
            </FormLabel>
          </FormControl>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "10px",
            }}
          >
            <Button
              onClick={() => {
                setShow(false);
              }}
              variant="contained"
              type="submit"
              className="mpl-primary-btn profile-btn"
              size="small"
              sx={{
                margin: "10px",
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Popup>
      <>
        <Box
          sx={{
            maxHeight: "87vh",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ pt: 1, pb: 1 }}>
            <form
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "9px",
              }}
            >
              <Box
                sx={{
                  padding: "5px",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  border: "1px solid #dce3ea",
                  cursor: visitorLoading ? "not-allowed" : "pointer",
                  opacity: visitorLoading ? 0.6 : 1,
                  transition: "all 0.2s ease-in-out",
                  pointerEvents: visitorLoading ? "none" : "auto",
                  "&:hover": {
                    backgroundColor: visitorLoading ? "#ffffff" : "#e8f5e9",
                  },
                }}
                onClick={!visitorLoading ? handleDownload : undefined}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 500,
                    color: "#1976d2",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      display: "inline-block",
                      fontSize: "20px",
                      animation: visitorLoading
                        ? "spin 1s linear infinite"
                        : "none",
                      "@keyframes spin": {
                        "0%": { transform: "rotate(0deg)" },
                        "100%": { transform: "rotate(360deg)" },
                      },
                    }}
                  >
                    📄
                  </Box>
                  Download Sample CSV Template
                </Typography>
              </Box>
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {file ? (
                    <p style={{ margin: 0 }}>{file.name.substring(0, 20)}...</p>
                  ) : errors?.selectedFile ? (
                    <p style={{ color: "red", margin: 0 }}>No file chosen</p>
                  ) : (
                    <p style={{ margin: 0 }}>No file chosen</p>
                  )}
                </div>
                <label
                  htmlFor="contained-button-file"
                  style={{ display: "none" }}
                >
                  <input
                    accept=".csv"
                    id="contained-button-file"
                    type="file"
                    style={{ display: "none" }}
                    multiple={false}
                    onChange={fileSelected}
                  />
                </label>
                <Button
                  variant="contained"
                  className="mpl-primary-btn"
                  component="span"
                  sx={{ marginBottom: "5px" }}
                  onClick={handleSelectFileClick}
                  disabled={getLoading}
                >
                  Select File
                </Button>
                <Button
                  variant="contained"
                  className="mpl-primary-btn"
                  sx={{ marginBottom: "5px", marginRight: "5px" }}
                  disabled={!visitorData || visitorData?.length === 0}
                  onClick={handleSubmit}
                >
                  Next
                </Button>
              </div>
            </form>
          </Box>

          <MaterialTable
            isLoading={getLoading || gridLoading}
            columns={[
              {
                title: "Guest Name",
                cellStyle: { padding: "10px 10px 10px 13px" },
                field: "visitors_name",
                grouping: false,
                render: (rowData) => rowData?.visitors_name || "-",
              },
              {
                title: "Guest Mobile Number",
                cellStyle: { padding: "10px 10px 10px 13px" },
                field: "visitors_mobile_no",
                grouping: false,
                render: (rowData) => rowData?.visitors_mobile_no || "-",
              },
              {
                title: "Visit Date",
                cellStyle: { padding: "10px 10px 10px 13px" },
                field: "booking_date",
                render: (rowData) => rowData?.booking_date ? revertDateFormat(rowData?.booking_date) : "-",
              },
              {
                title: "Host",
                cellStyle: { padding: "10px 10px 10px 13px" },
                field: "visited_employee_name",
                render: (rowData) => rowData?.visited_employee_name || "-",
              },
              {
                title: "Purpose",
                cellStyle: { padding: "10px 10px 10px 13px" },
                field: "reason",
                render: (rowData) => rowData?.reason || "-",
              },
            ]}
            data={visitorData}
            options={{
              maxBodyHeight: "55vh",
              minBodyHeight: "55vh",
              rowStyle: { fontSize: "13px" },
              headerStyle: {
                padding: "10px 10px 10px 13px",
                fontWeight: "bold",
                position: "sticky",
                top: 0,
              },
              sorting: true,
              search: true,
              searchText: "",
              searchFieldAlignment: "right",
              searchAutoFocus: true,
              searchFieldVariant: "standard",
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              paginationPosition: "bottom",
              exportButton: false,
              exportAllData: false,
              exportFileName: "Visitors",
              addRowPosition: "first",
              selection: false,
              actionsColumnIndex: -1,
              showSelectAllCheckbox: true,
              showTextRowsSelected: true,
              grouping: false,
              columnsButton: false,
              toolbar: true,
            }}
            actions={[
              {
                icon: () => (
                  <IconButton sx={{ padding: "0px" }}>
                    <EditIcon />
                  </IconButton>
                ),
                tooltip: "Edit",
                onClick: (_event, rowData) => {
                  handleEdit(rowData);
                },
              },
              {
                icon: () => (
                  <IconButton sx={{ padding: "0px" }}>
                    <DeleteIcon />
                  </IconButton>
                ),
                tooltip: "Delete",
                onClick: (_event, rowData) => {
                  handleConfirmDelete(rowData);
                },
              },
            ]}
            title="Visitor Bulk Pre-Registration"
          />
          <Popup
            maxWidth="sm"
            fullWidth={true}
            title="Map the column headers from your sheet & Meepl Fields"
            openPopup={file}
            close={false}
            setOpenPopup={setOpenBulk}
          >
            <Box>
            <Grid container spacing={2}
                sx={{
                    alignItems: "center",
                    mb: 1.5
                }}
            >
              <Grid item xs={6} >
                <FormControl fullWidth>
                    <SelectableSearch
                    label="Select Person"
                    value={bulkFormData?.employee_id}
                    loading={() => handleEmployees()}
                    fieldLabel="name"
                    required={true}
                    name="employee_id"
                    size="small"
                    onChangeEvent={(e, v) => {
                        setBulkFormData((prev) => ({ ...prev, [e]: v }));
                        setErrors((prev) => ({ ...prev, [e]: ""}));
                    }}
                    data={employeesData}
                    variantType="standard"
                    {...(errors.employee_id && {
                        error: true,
                        helperText: errors.employee_id,
                    })}
                    />
                </FormControl>
                </Grid>
                <Grid item xs={6}>
                <Typography>
                    Host/Person to Meet *
                </Typography>
                </Grid>
                {whatsAppFlow && (
                  <>
                    <Grid item xs={6}>
                      <RadioGroup
                        row
                        value={sendWhatsappMsg}
                        onChange={handleWhatsappRadioChange}
                      >
                        <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
                        <FormControlLabel value="no" control={<Radio size="small" />} label="No" />
                      </RadioGroup>
                    </Grid>
                    <Grid item xs={6}>
                      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                        <Typography>
                          Send WhatsApp Invite
                        </Typography>
                        <Tooltip title="Send Visitor Pass & Check-In QR link to the guest via WhatsApp" arrow placement="top">
                          <InfoOutlinedIcon fontSize="small" sx={{ fontSize: 16, color: "text.secondary", cursor: "pointer" }} />
                        </Tooltip>
                      </Box>
                    </Grid>
                  </>
                )}
            </Grid>
              <Box
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  alignItems: "center",
                  padding: 5,
                  borderBottom: "1px solid gray",
                }}
              >
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  Imported Headers
                </Typography>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  Meepl Fields
                </Typography>
              </Box>
              {excelDbColMapping.map((col) => (
                <Grid
                  key={col.db}
                  container
                  spacing={2}
                  style={{
                    padding: 5,
                    alignItems: "center",
                  }}
                >
                  <Grid
                    sx={{ mt: 2 }}
                    item
                    xs={6}
                    container
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item xs>
                      <Select
                        onChange={(e) => setColMapping(e.target.value, col.db)}
                        value={col.excel}
                        fullWidth
                        required={col.required}
                        variant="standard"
                      >
                        {rowHeaders.map((header) => (
                          <MenuItem key={header} value={header}>
                            {header}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    {col.excel && (
                      <Grid item>
                        <IconButton onClick={() => clearColMapping(col.db)}>
                          <CloseIcon />
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>
                  <Grid sx={{ mt: 2 }} item xs={6}>
                    <Typography>
                      {col.label || col.db}
                      {col.required && " *"}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", m: 2 }}
            >
              <Button
                onClick={() => {
                  setFile(null);
                  setRowHeaders([]);
                  setOpenBulk(false);
                }}
                className="mpl-primary-btn"
                disabled={uploadProgress > 0 && uploadProgress < 100}
              >
                Close
              </Button>
              <Button
                variant="contained"
                type="submit"
                className="mpl-primary-btn"
                disabled={uploadProgress > 0 && uploadProgress < 100}
                onClick={addVisitorStage}
                startIcon={
                  uploadProgress > 0 && uploadProgress < 100 ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : null
                }
              >
                Upload
              </Button>
            </Box>
          </Popup>
          <Popup
            maxWidth="xs"
            fullWidth={true}
            title="Attention Needed!"
            openPopup={showConfirmPopup}
            close={false}
            setOpenPopup={setShowConfirmPopup}
          >
            <Typography variant="h5">
              {" "}
              You will lose the imported data. Do you want to submit it before
              proceeding?{" "}
            </Typography>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <Button
                onClick={handleCancel}
                className="mpl-primary-btn"
                disabled={loader}
                startIcon={
                  loader ? <CircularProgress size={18} color="inherit" /> : null
                }
              >
                No
              </Button>

              <Button
                onClick={() => {
                  setShowConfirmPopup(false); // Close popup and retain existing data
                }}
                className="mpl-primary-btn"
              >
                Yes
              </Button>
            </Box>
          </Popup>
          <Popup
            title={"Edit Visitor"}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleEditSubmit(editedRecord); // Call edit submit with updated record
              }}
            >
              <TextField
                size="small"
                label="Guest Name"
                value={editedRecord?.visitors_name || ""}
                onChange={(e) =>
                  setEditedRecord({
                    ...editedRecord,
                    visitors_name: e.target.value,
                  })
                }
                fullWidth
                sx={{ mb: 3 }}
                required
                {...(editerrors.visitors_name && {
                  error: true,
                  helperText: editerrors.visitors_name,
                })}
              />
              <TextField
                size="small"
                label="Guest Mobile Number"
                value={editedRecord?.visitors_mobile_no || ""}
                required
                type="number"
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) {
                    setEditedRecord({
                      ...editedRecord,
                      visitors_mobile_no: value,
                    });
                  }
                }}
                fullWidth
                sx={{ mb: 3 }}
                {...(editerrors.visitors_mobile_no && {
                  error: true,
                  helperText: editerrors.visitors_mobile_no,
                })}
              />
              <FormControl fullWidth sx={{ mb: 3 }}>
                <CommonDatePicker
                  required
                  size="small"
                  name="booking_date"
                  label="Visit Date"
                  pickerType="date"
                  onKeyPress={(e) => e.preventDefault()}
                  onKeyDown={(e) => e.preventDefault()}
                  pickerFormat="dd/MM/yyyy"
                  DefaultDTvalue={editedRecord?.booking_date}
                  handleChange={(value) =>
                    setEditedRecord({
                      ...editedRecord,
                      booking_date: value
                        ? `${value.getFullYear()}-${("0" + (value.getMonth() + 1)).slice(-2)}-${("0" + value.getDate()).slice(-2)}`
                        : "",
                    })
                  }
                  {...(editerrors.booking_date && {
                    error: true,
                    helperText: editerrors.booking_date,
                  })}
                />
              </FormControl>
              <TextField
                size="small"
                label="Purpose of Visit"
                value={editedRecord?.reason || ""}
                onChange={(e) =>
                  setEditedRecord({ ...editedRecord, reason: e.target.value })
                }
                fullWidth
                sx={{ mb: 3 }}
                required
                {...(editerrors.reason && {
                  error: true,
                  helperText: editerrors.reason,
                })}
              />

              {/* Add other fields similarly */}
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
              >
                <Button
                  onClick={() => setOpenPopup(false)}
                  className="mpl-primary-btn"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  className="mpl-primary-btn"
                >
                  Save
                </Button>
              </Box>
            </form>
          </Popup>
          <ConfirmationDialog
            title="Do you wish to proceed?"
            openDialog={openDialog}
            closeDialog={setOpenDialog}
            OkButtonText="Delete"
            onSubmit={handleDelete}
          />
  
        {/* validate each field before stage to main - warning*/}
          <Popup
            title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <WarningAmberIcon color="warning" fontSize="small" />
                        {resWarData?.type || "Warning"}
                    </Box>
                    <Tooltip title="Export as Excel" arrow>
                        <IconButton size="small" onClick={handleExportWarningListExcel}>
                            <CloudDownloadIcon sx={{ color: "inherit" }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            }
            openPopup={(resWarData?.isOpen && id === resWarData?.stage_visitor_pk) || false}
            setOpenPopup={() => setResWarData({})}
        >
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell width={120}><b>Guest Name</b></TableCell>
                            <TableCell><b>{resWarData?.type === "Warning" ? "Warnings" : "Reasons"}</b></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {Object.values(resWarData?.warning || [])?.map((item, idx) => (
                            <TableRow key={idx} sx={{ "& td": { py: 1 }, "&:not(:last-child)": { borderBottom: "2px solid #fff" } }}>
                                <TableCell>{item?.visitor_name || "-"}</TableCell>
                                <TableCell>
                                    {Array.isArray(item?.reasons) && item.reasons.length > 0 ? (
                                        item.reasons.map((r, i) => (
                                        <div key={i}>• {r}</div>
                                        ))
                                    ) : (
                                        "-"
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography
                variant="body2"
                sx={{
                    mt: 2,
                    color: "warning.main",
                    fontWeight: 500,
                }}
                >
                {resWarData?.type === "Warning" ? "Please fill in the required fields for the listed records or delete the invalid records before proceeding." : "Note: The listed Purpose of Visit values are either not configured or do not match exactly. Please verify the spelling, spaces and letter casing, then try again for these guests."}
                
            </Typography>
        </Popup>
        </Box>
      </>
    </>
  );
};

export default PreRegistrationBulkUpload;
